import { useTranslation } from "react-i18next"
import { Badge } from "@/components/ui/badge"
import { User, Users } from "lucide-react"
import { ListingProfileListingType } from "@/types/serializers"
import { cn } from "@/lib/utils"

export function ListingTypeBadge({
  listingType,
  className,
}: {
  listingType: ListingProfileListingType
  className?: string
}) {
  const { t } = useTranslation("common")

  const Icon = {
    team: Users,
    personal: User,
  }[listingType]

  return (
    <Badge variant="default" className={cn("text-xs", className)}>
      <Icon className="mr-1 h-8 w-8" />
      <span data-testid="listing-type">
        {t(`listing_profiles.listing_type.${listingType}`)}
      </span>
    </Badge>
  )
}
